import { css } from "emotion";
import { Stack } from "../../layouts/Stack";
import { Typography } from "../Typography";

export const ColorOption = ({
  label,
  textColor,
  backgroundColor
}: {
  label: string;
  textColor: string;
  backgroundColor: string;
}) => {
  return (
    <Stack direction="horizontal" gap="8" align="center">
      {/* Makes a circle shape for the color option */}
      <div
        className={css({
          width: "1rem",
          height: "1rem",
          borderRadius: "50%",
          backgroundColor: backgroundColor
        })}
      ></div>

      <Typography
        className={css({
          color: `${textColor}`
        })}
      >
        {label}
      </Typography>
    </Stack>
  );
};
